<template>
  <div class="container d-xs-block d-sm-block d-md-none mb-3">
    <div class="row">
      <div class="col-12 price-section">
        <div class="label mb-2">
          Prix de vente
        </div>

        <div class="value mb-2">
          {{ price }} €
        </div>
        <div
          class="value_m2"
        >
          {{ m2Price }} €/m²
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  propertyData?: Record<string, any>
}>()

const price = computed(() => {
  return numberWithSpace(Math.round(props.propertyData?.price.value))
})

const m2Price = computed(() => {
  return numberWithSpace(Math.round(props.propertyData?.price.value / props.propertyData?.area.value))
})

</script>

<style lang="scss" scoped>
.price-section,
.address {
  padding-left: 0;
}

.price-section .label {
  font-size: 16px;
  font-weight: normal;
  color: #1f1f1f;
}

.price-section .value {
  font-size: 41px;
  font-weight: bold;
  color: $purple;
}

.price-section .value_m2 {
  font-size: 18px;
  font-weight: bold;
  color: $purple;
}

.address-section {
  width: 100%;
  margin-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  color: #1f1f1f;
  font-size: 14px;
  border-bottom: 1px solid #edf1fa;
}

.address-section p {
  margin-bottom: 1px;
  font-size: 16px;
}

.address-section span.underlined {
  text-decoration: underline;
  font-weight: normal;
  cursor: pointer;
}

.adress-section span {
  font-size: 12px;
}

.ref {
  font-size: 12px;
  padding-top: 30px;
  text-align: right;
}

.see {
  padding-top: 10px;
  font-size: 12px;
}
</style>
